/*
 * 성별 표시 문자열. 구 String.prototype.genderShortString 대체.
 * (genderString('여성'/'남성')은 사용처가 없어 이관하지 않음)
 */
export const formatGenderShort = (value: string | null | undefined): string => {
  if (value === 'F') {
    return '여'
  }
  if (value === 'M') {
    return '남'
  }
  return '-'
}
